<template>
    <div v-if="loading" class="text-center mt-5">
        <div class="spinner-border" role="status">
        </div>
    </div>
    <div v-else>
        <NavbarView :data="data" :apiUrlStorage="apiUrlStorage"></NavbarView>
        <div class="ancillaries-container"
            :style="{ background: data.brand.whitelabel_config.mainBackgroundColor, fontFamily: data.brand.whitelabel_config.fontFamily }">
            <div v-if="queryParams.redirect_status == 'succeeded'" class="thank-you-container">
                <ThankYouView :data="data" />
            </div>
            <div v-else>
                <PaymentUnsuccessful :data="data" />
            </div>
        </div>
    </div>

</template>


<script>

import { mapActions, mapState, mapGetters } from "vuex";
import ThankYouView from "./ThankYouView.vue";
import PaymentUnsuccessful from "./PaymentUnsuccessful.vue";
import NavbarView from "./NavbarView.vue";

export default {
    components: {
        NavbarView,
        ThankYouView,
        PaymentUnsuccessful
    },

    async mounted() {
        await this.loadData({
            id: this.$route.params.id,
            signature: this.$route.query.signature, 
        });

        window.addEventListener('resize', this.reloadPage);
    },

    data() {
        return {
            queryParams: this.$route.query,
        };
    },

    methods: {
        ...mapActions(['loadData', 'reloadPage']),
    },

    computed: {
        ...mapGetters(['disableCheckout']),
        ...mapState(['loading', 'data', 'apiUrlStorage']),
    },

}
</script>

<style scoped>
.thank-you-container{
  min-height: calc(100vh - 100px);
}
</style>